/*
 * (migrated to Vite) See prior header in index.js
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './App.jsx';
import './index.css';
import './App.css';
import messages_fr from './translations/fr.json';
import messages_en from './translations/en.json';
import messages_it from './translations/it.json';
import messages_es from './translations/es.json';
import messages_nl from './translations/nl.json';
import messages_pt from './translations/pt.json';
import { IntlProvider } from 'react-intl';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext.jsx';

const messages = { fr: messages_fr, en: messages_en, it: messages_it, es: messages_es, nl: messages_nl, pt: messages_pt };

// Désenregistrement du service worker et suppression du cache - AVANT le render
(async () => {
  const CACHE_VERSION = 'v20251013'; // Changez cette version pour forcer le rechargement
  const currentVersion = localStorage.getItem('app-cache-version');
  
  if (currentVersion !== CACHE_VERSION) {
    console.log('Nettoyage du cache et service workers...');
    
    // Désenregistrer tous les service workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(r => r.unregister()));
    }
    
    // Supprimer tous les caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    }
    
    // Marquer la version comme nettoyée
    localStorage.setItem('app-cache-version', CACHE_VERSION);
    
    // Forcer le rechargement complet (sans cache)
    window.location.reload(true);
    return;
  }
})();

// Composant wrapper pour IntlProvider avec le contexte de langue
const IntlWrapper = () => {
  const { language, currentMessages } = useLanguage();
  
  return (
    <IntlProvider locale={language} messages={currentMessages}>
      <App />
    </IntlProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LanguageProvider messages={messages}>
    <IntlWrapper />
  </LanguageProvider>
);
